document.addEventListener('alpine:init', () => {
  // Fallback ohne Netzabfrage – greift nur, wenn Shopify kein Land liefert.
  const TIMEZONE_COUNTRY = {
    'Europe/Berlin': 'DE',
    'Europe/Busingen': 'DE',
    'Europe/Vienna': 'AT',
    'Europe/Zurich': 'CH',
  };

  Alpine.data('Theme_ShippingNoticePopup', (settings) => ({
    shown: false,
    enabled: settings.enabled,
    sectionId: settings.sectionId,
    frequency: settings.frequency,
    shopCountry: (settings.shopCountry || '').toUpperCase(),
    countries: (settings.countries || '')
      .split(',')
      .map((code) => code.trim().toUpperCase())
      .filter(Boolean),
    debug: false,

    async init() {
      const params = new URLSearchParams(window.location.search);
      this.debug = params.has('shipping_notice_debug');

      if (window.Shopify && Shopify.designMode) {
        this.initDesignMode();
        return;
      }

      if (params.get('shipping_notice') === '1') {
        this.shown = true;
        return;
      }

      if (!this.enabled) return this.log('Section deaktiviert');
      if (window.location.pathname === '/challenge') return;
      if (this.wasDismissed()) return this.log('Bereits geschlossen');

      const country = await this.resolveCountry();
      this.log('Erkanntes Land:', country, '| Zielländer:', this.countries);

      if (!country || !this.countries.includes(country)) return;

      this.shown = true;
    },

    initDesignMode() {
      if (window.theme?.designMode?.selected === this.sectionId) {
        this.shown = this.enabled;
      }

      document.addEventListener('shopify:section:select', (event) => {
        if (!event.target.contains(this.$root)) return;
        if (!this.enabled) return;
        this.shown = true;
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (!event.target.contains(this.$root)) return;
        this.shown = false;
      });
    },

    async resolveCountry() {
      const detected = await this.detectCountryByIp();
      if (detected) return detected;

      this.log('Shopify-Erkennung fehlgeschlagen, nutze Fallbacks');

      if (this.countries.includes(this.shopCountry)) return this.shopCountry;

      try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (TIMEZONE_COUNTRY[timezone]) return TIMEZONE_COUNTRY[timezone];
      } catch (error) {
        // Intl nicht verfügbar
      }

      const region = (navigator.language || '').split('-')[1];
      return region ? region.toUpperCase() : this.shopCountry;
    },

    // Shopify liefert hier das per IP erkannte Land – funktioniert auch hinter VPN.
    async detectCountryByIp() {
      try {
        const response = await fetch(
          '/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true',
          { headers: { Accept: 'application/json' } }
        );

        if (!response.ok) return null;

        const data = await response.json();
        const handle = data?.detected_values?.country?.handle;
        return handle ? String(handle).toUpperCase() : null;
      } catch (error) {
        return null;
      }
    },

    storageKey() {
      return `shipping_notice_dismissed_${this.sectionId}`;
    },

    wasDismissed() {
      if (this.frequency === 'always') return false;

      try {
        if (this.frequency === 'session') {
          return sessionStorage.getItem(this.storageKey()) === '1';
        }

        const until = localStorage.getItem(this.storageKey());
        return Boolean(until) && Date.now() < Number(until);
      } catch (error) {
        return false;
      }
    },

    close() {
      this.shown = false;

      if (this.frequency === 'always') return;

      try {
        if (this.frequency === 'session') {
          sessionStorage.setItem(this.storageKey(), '1');
        } else {
          const days = this.frequency === 'week' ? 7 : 1;
          localStorage.setItem(
            this.storageKey(),
            String(Date.now() + days * 24 * 60 * 60 * 1000)
          );
        }
      } catch (error) {
        // Storage nicht verfügbar – Popup erscheint beim nächsten Aufruf erneut
      }
    },

    log(...args) {
      if (this.debug) console.log('[Shipping notice]', ...args);
    },
  }));
});
